import React, { useState } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import MessageSkeleton
  from 'Components/ComponentLibrary/Atoms/Skeletons/MessageSkeleton';
import MeetingCommunicationHeader
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/MeetingCommunicationMessageContent/MeetingCommunicationHeader';
import MeetingCommunicationBody
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/MeetingCommunicationMessageContent/MeetingCommunicationBody';
import { noop } from 'Helpers/PropTypes';
import { FDStack } from '@facet-wealth/design';

const MeetingCommunicationMessageContent = ({
  messageResource,
  onLoadComplete,
}) => {
  const [meetingRes, setMeetingRes] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [incompleteClientActionItemResource, setIncompleteClientActionItemResource] = useState(null);
  const [incompletePlannerActionItemResource, setIncompletePlannerActionItemResource] = useState(null);
  const [attachmentsCollection, setAttachmentsCollection] = useState(null);

  const meetingAgenda = messageResource.attr('meetingAgendas')?.resources().head();

  const fetchMeetingResources = async () => {
    const attachments = await meetingAgenda?.relationship(fr.relationships.attachments.name).link('related').get();
    setAttachmentsCollection(attachments);

    const [fetchedMeetingResource] = await meetingAgenda?.relationship(fr.relationships.meeting.name)?.link('related').get();

    const incompleteClientItems = await fetchedMeetingResource?.relationship(fr.relationships.incompleteClientActionItems.name)?.link('related').get();
    const incompletePlannerItems = await fetchedMeetingResource?.relationship(fr.relationships.incompletePlannerActionItems.name)?.link('related').get();

    setMeetingRes(fetchedMeetingResource);
    setIncompleteClientActionItemResource(incompleteClientItems?.resources()?.list());
    setIncompletePlannerActionItemResource(incompletePlannerItems?.resources()?.list());
  };


  useComponentDidMount(async () => {
    setIsLoading(true);
    await fetchMeetingResources();
    setIsLoading(false);
    onLoadComplete();
  });

  if (isLoading) {
    return (
      <MessageSkeleton />
    );
  }

  return (
    <FDStack direction={'column'} spacing={3}>
      <MeetingCommunicationHeader meetingAgenda={meetingAgenda} meetingResource={meetingRes} />
      <MeetingCommunicationBody
        meetingAgenda={meetingAgenda}
        messageContent={messageResource.attr('content')}
        incompletePlannerActionItemResource={incompletePlannerActionItemResource}
        incompleteClientActionItemResource={incompleteClientActionItemResource}
        attachmentsCollection={attachmentsCollection}
      />
    </FDStack>
  );
};

MeetingCommunicationMessageContent.defaultProps = {
  onLoadComplete: noop,
};

MeetingCommunicationMessageContent.propTypes = {
  messageResource: PropTypes.object.isRequired,
  onLoadComplete: PropTypes.func,
};

export default MeetingCommunicationMessageContent;
